import { NgModule } from '@angular/core';
import { RouterModule, Router, NavigationEnd, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { NotificationsComponent } from './shared/layout/notifications/notifications.component';
import { AppComponent } from './app.component';
import { AppRouteGuard } from './shared/common/auth/auth-route-guard';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: 'app',
                component: AppComponent,
                canActivate: [AppRouteGuard],
                canActivateChild: [AppRouteGuard],
                children: [
                    {
                        path: '',
                        children: [
                            { path: 'notifications', component: NotificationsComponent },
                            { path: '', redirectTo: '/app/admin/hostDashboard', pathMatch: 'full' }
                        ]
                    },
                    {
                        path: 'main',
                        loadChildren: 'app/main/main.module#MainModule', //Lazy load main module
                        data: { preload: true }
                    },
                    {
                        path: 'financial',
                        loadChildren: 'app/financial/financial.module#FinancialModule', //Lazy load financial module
                        data: { preload: true }
                    },
                    {
                        path: 'event',
                        loadChildren: 'app/event/event.module#EventModule', //Lazy load event module
                        data: { preload: true }
                    },
                    {
                        path: 'annuity',
                        loadChildren: 'app/annuity/annuity.module#AnnuityModule', //Lazy load annuity module
                        data: { preload: true }
                    },
                    {
                        path: 'report',
                        loadChildren: 'app/report/report.module#ReportModule', //Lazy load report module
                        data: { preload: true }
                    },
                    {
                        path: 'store',
                        loadChildren: 'app/store/store.module#StoreModule', //Lazy load store module
                        data: { preload: true }
                    },
                    {
                        path: 'scientific',
                        loadChildren: 'app/scientific/scientific.module#ScientificModule', //Lazy load scientific module
                        data: { preload: true }
                    },
                    {
                        path: 'scientificWork',
                        loadChildren: 'app/scientific-work/scientific-work.module#ScientificWorkModule', //Lazy load scientific-work module
                        data: { preload: true }
                    },
                    {
                        path: 'admin',
                        loadChildren: 'app/admin/admin.module#AdminModule', //Lazy load admin module
                        data: { preload: true }
                    }
                    , {
                        path: '**', redirectTo: 'notifications'
                    }
                ]
            }
        ])
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
    constructor(
        private router: Router
    ) {
        router.events.subscribe((event) => {

            if (event instanceof RouteConfigLoadStart) {
                abp.ui.setBusy();
            }

            if (event instanceof RouteConfigLoadEnd) {
                abp.ui.clearBusy();
            }

            if (event instanceof NavigationEnd) {
                $('meta[property=og\\:url]').attr('content', window.location.href);
            }

        });
    }
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts